var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AreaFormModel } from '@/models/CampaignOperation/Form/AreaForm';
import { POIConditionFormModel } from './POIConditionForm';
import { TargetAreaTypes } from '@/models/CampaignOperation';
import { POISearchRepository } from '@/models/POI/POISearchRepository';
var POISearchFormModel = /** @class */ (function () {
    function POISearchFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, name = _a.name, categoryId = _a.categoryId, area = _a.area;
        this.name = name === undefined ? name : '';
        this.categoryId = categoryId;
        this.conditions = [POIConditionFormModel.assign()];
        this.administrativeDistrictType = TargetAreaTypes.PREFECTURE;
        this.area = AreaFormModel.assign(area);
    }
    POISearchFormModel.assign = function (data) {
        return new POISearchFormModel(data);
    };
    POISearchFormModel.prototype.addCondition = function () {
        this.conditions.push(POIConditionFormModel.assign());
    };
    POISearchFormModel.prototype.removeCondition = function (index) {
        this.conditions.splice(index, 1);
    };
    POISearchFormModel.prototype.removeSubcategory = function (subcategoryId) {
        this.conditions = this.conditions.filter(function (condition) {
            return condition.poiSubCategoryId !== subcategoryId;
        });
    };
    POISearchFormModel.prototype.removePrefectureOrCity = function (id) {
        if (this.administrativeDistrictType === TargetAreaTypes.PREFECTURE) {
            this.area.prefectureAreaObj.removePrefecture(id);
        }
        else {
            this.area.cityAreaObj.removeCity(id);
        }
    };
    POISearchFormModel.prototype.searchPoiLocationList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var conditions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.categoryId)
                            return [2 /*return*/, []];
                        conditions = this.conditions;
                        if (this.isPoiSearchConditionsEmpty())
                            conditions = [];
                        return [4 /*yield*/, POISearchRepository.getPoiLocationList(this.categoryId, conditions, this.administrativeDistrictType, this.convertArea(this.area))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    POISearchFormModel.prototype.isPoiSearchConditionsEmpty = function () {
        if (this.conditions.length === 0)
            return true;
        return (this.conditions.length === 1 &&
            this.conditions[0].poiSubCategoryId === null);
    };
    POISearchFormModel.prototype.resetConditions = function () {
        this.conditions = [POIConditionFormModel.assign()];
    };
    POISearchFormModel.prototype.emptyConditions = function () {
        this.conditions = [];
    };
    POISearchFormModel.prototype.convertArea = function (area) {
        var prefectureAreaObj = area.prefectureAreaObj, cityAreaObj = area.cityAreaObj;
        return {
            prefectureAreaObj: {
                countryId: prefectureAreaObj.countryId,
                prefectureIds: prefectureAreaObj.prefectureIds,
            },
            cityAreaObj: {
                countryId: cityAreaObj.countryId,
                prefectures: cityAreaObj.prefectures.map(function (prefecture) {
                    return {
                        prefectureId: prefecture.prefectureId,
                        cityIds: prefecture.cityIds,
                    };
                }),
            },
        };
    };
    return POISearchFormModel;
}());
export { POISearchFormModel };
